module.exports = __webpack_public_path__ + "img/expired.e1216396.png";